import React from 'react';
import classNameBind from 'classnames/bind';
import round from 'lodash/round';
import { withTranslation } from '../../../Translator';
import Icon from '../../../Icon';
import Tooltip from '../../../Tooltip';
import generateComparisonColor from '../../../../utils/methods/generateComparisonColor';
import styles from './Trend.module.css';

const bindClasses = classNameBind.bind(styles);
const formatPercent = (number, t) => (
  `${t('number', { number: round(number * 100, 2) })}%`
);

const Trend = ({ value, reverseComparisonColor, t } = {}) => {
  const percents = formatPercent(value, t);

  return (
    <Tooltip content={percents}>
      <div
        className={bindClasses('wrapper', 'cut-text', generateComparisonColor(value, reverseComparisonColor))}
        data-ppuc-id="Counter.Trend"
      >
        {value !== 0 && (
          <Icon name={`trend-${value > 0 ? 'up' : 'down'}`} className={bindClasses('icon')} color={generateComparisonColor(value, reverseComparisonColor)} />
        )}
        {percents}
      </div>
    </Tooltip>
  );
};

const enhanced = withTranslation('components')(Trend);
enhanced.displayName = 'Trend';

export default enhanced;
export const PureComponent = Trend;
